import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Dumbbell, Heart } from 'lucide-react';
import { Button } from '../ui/button';

export const RecentActivity = ({ recentWorkouts }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.7 }}
  >
    <div className="flex items-center justify-between mb-3">
      <h3 className="font-heading text-lg text-white uppercase tracking-wider">Recent Activity</h3>
      <Link to="/history" className="text-primary hover:underline text-xs font-medium">View All</Link>
    </div>
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2">
      {recentWorkouts.length > 0 ? recentWorkouts.map((log) => (
        <div key={log.id} className="bg-card border border-border rounded-xl p-3 flex items-center justify-between gap-3" data-testid="recent-workout">
          <div className="flex items-center gap-2.5 min-w-0 flex-1">
            <div className="h-9 w-9 shrink-0 bg-primary/10 rounded-lg flex items-center justify-center">
              <Dumbbell className="h-4 w-4 text-primary" />
            </div>
            <div className="min-w-0">
              <p className="text-white text-sm font-medium leading-tight truncate">{log.workout_title}</p>
              <p className="text-muted-foreground text-xs leading-tight mt-0.5">{log.duration_minutes} min · {log.calories_burned} cal</p>
            </div>
          </div>
          <span className="text-muted-foreground text-[11px] shrink-0">
            {new Date(log.completed_at).toLocaleDateString()}
          </span>
        </div>
      )) : (
        <div className="bg-card border border-border rounded-xl p-4 text-center col-span-full">
          <Heart className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
          <p className="text-muted-foreground text-sm">No workouts logged yet</p>
          <Link to="/workouts">
            <Button size="sm" className="mt-3 h-9 text-xs bg-primary text-primary-foreground font-heading tracking-wider">
              Start Your First Workout
            </Button>
          </Link>
        </div>
      )}
    </div>
  </motion.div>
);
